import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { Disclosures } from 'src/app/models/disclosures';
import { DisclosuresService } from 'src/app/services/disclosures.service';
import { SafePipe } from 'src/app/pipes/safe.pipe';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    imports:[SafePipe]
})
export class HistoryComponent implements OnInit {

  title = "Investing for Catholics History of Disclosure Changes.";

  history: Disclosures[]

  constructor(private disclosuresservice: DisclosuresService, private seoservice: SeoService, private meta: Meta) {

    this.disclosuresservice.getHistory().subscribe(resp => {
   
      //removes first article from header
      this.history = resp;
   
    })
// $&(this.history)

   }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'investing for catholic disclosures, history of disclosures, ifc history of disclosures'});
    this.meta.addTag({name: 'description', content: 'History of disclosures details the changes to indexes and socially responsible index portfolios in IFCs portfolio.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
